import { Identifiable } from '../Identifiable';
import { BlueprintParameter } from 'src/app/models/blueprints/blueprint-parameter';
import { PathToLiveConfiguration } from './path-to-live-configuration';

export interface Blueprint extends Identifiable {
  onboardingProcess: any;
  name: string;
  demo: boolean;
  tenantId?: string;
  solutionId: string;
  pathToLiveConfiguration?: PathToLiveConfiguration[];
  installationDocument?: string;
  region: string;
  updateWindowPolicy: string;
  dateCreated: Date;
  capabilities?: any;
  solutionName?: string;
  version?: string;
  isAMR?: boolean;
  selectedISBType?:any;
}

export enum BlueprintTypes {
  INSTANCES = 'Environments',
  SERVICE_DEFINITION = 'Service Definition',
  LIVE_METRICS = 'Live Metrics',
  USAGE_AND_COST = 'Usage and Cost',
  LOG = 'Log'
}

export enum InstanceTabs {
  OVERVIEW = 'Overview',
  VIEW_ENDPOINTS = 'View Endpoints',
  RELEASE_PACKAGE = 'Release Package'
}

export enum ISBModes {
  SYSTEM = 'system',
  EXTERNAL = 'external'
}
